var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.loading)?_c('div',{staticClass:"spinner-overlay"},[_c('div',{staticClass:"spinner-card"},[_c('div',{staticClass:"spinner"}),(_vm.$store.state.loadingMessage)?_c('p',{staticClass:"spinner-text"},[_vm._v(" "+_vm._s(_vm.$store.state.loadingMessage)+" ")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }